<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <div class="goBack" @click="goBack">
        <i class="goback-icon-cla"></i>
        <span>{{ $t('developer.goback') }}</span>
      </div>
    </div>

    <zkThreeRow>
      <div slot="search" style="height:100px;display:flex;align-items: center;">
        <el-upload
          class="upload-demo"
          action="/apiv1/hr/company/uploadCompanyLogo"
          :show-file-list="false"
          :data="datas"
          :on-success="handleAvatarSuccess"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imgUrl" :src="imgUrl" class="avatar" />
          <div v-else class="upload_div">
            <i class="el-icon-plus el-icon-upload"></i>
          </div>
        </el-upload>
        <div style="padding: 0 20px ;">
          <span style="font-weight:700"
            >{{ companyDetails.companyName }}
            <i class="el-icon-edit edit_company" @click="editCompany"></i
          ></span>
          <div>
            <span
              style="display:inline-block;width:200px;color:#cccccc;font-size:14px;line-height:16px"
              >{{ $t('company.industry') }}:{{ companyDetails.industry }}</span
            >
            <span style=";color:#cccccc;font-size:14px;line-height:16px"
              >{{ $t('company.webSite') }}:{{ companyDetails.website }}</span
            >
          </div>
        </div>
      </div>

      <div slot="table">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="1" :label="$t('company.cmpInfo')">
            <companyInformaion
              v-if="activeName === '1'"
              :companyDetailsInfo="companyDetails"
              :contryCode="contryCode"
            ></companyInformaion>
          </el-tab-pane>

          <el-tab-pane
            name="4"
            :label="$t('user.accountByLogin')"
            v-if="isShowAdminAccount !== 0"
          >
            <adminAccount
              v-if="activeName === '4'"
              :currentRow="companyDetails"
            ></adminAccount>
          </el-tab-pane>

          <el-tab-pane name="3" :label="$t('company.devList')">
            <companyDevice
              style="margin-top:5px"
              v-if="activeName === '3'"
              :companyDevice="companyDetails"
              :isCmpDevice="true"
            ></companyDevice>
          </el-tab-pane>

          <el-tab-pane name="5" :label="$t('company.employeeList')">
            <companyEmployee
              :currentRow="companyDetails"
              v-if="activeName === '5'"
            ></companyEmployee>
          </el-tab-pane>
        </el-tabs>
      </div>
    </zkThreeRow>
    <el-dialog
      :title="$t('company.updateInfo')"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleClose"
    >
      <el-form
        :model="copyDetails"
        label-width="160px"
        ref="companyDetailsForm"
        :rules="rules"
      >
        <el-form-item :label="$t('tenant.owner')" prop="companyName">
          <el-input v-model="copyDetails.companyName"></el-input>
        </el-form-item>

        <el-form-item :label="$t('company.webSite')">
          <el-input v-model="copyDetails.website"></el-input>
        </el-form-item>

        <el-form-item :label="$t('company.industry')">
          <el-input v-model="copyDetails.industry"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('company.Contact')" prop="name">
          <el-input
            class="contact_input"
            :placeholder="this.$t('user.inputName')"
            v-model.trim="copyDetails.formattedName"
          ></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('company.country')" prop="countryCode">
          <el-select
            @change="changeCountry"
            v-model.trim="copyDetails.countryCode"
            filterable
            placeholder
            style="width:100%"
          >
            <el-option
              v-for="item in contryCode"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          class="form-item-cla flex-item-cla"
          :label="this.$t('company.phone')"
          prop="phone"
        >
          <el-input v-model="copyDetails.phone">
            <template slot="prepend">+{{ phonePrefix }}</template>
          </el-input>
        </el-form-item>

        <el-form-item
          class="form-item-cla flex-item-cla"
          :label="this.$t('company.email')"
          prop="email"
        >
          <el-input v-model.trim="copyDetails.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="sumbitEdit">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as companyApi from '@/services/companyApi'
import adminAccount from './detailPage/adminAccount'
import companyEmployee from './detailPage/companyEmployee.vue'
import companyDevice from '../../enterpriseAdmin/deviceManager/deviceManager'
import companyInformaion from './detailPage/companyInfomation'
import {
  validatorEmailRule,
  validatorPhoneRule,
  validatorInputEmptyRule
} from '@/utils/validatorRule.js'
export default {
  data() {
    let checkPhone = (rules, value, callback) => {
      if (!value) {
        return callback()
      }
      if (value && !this.copyDetails.countryCode) {
        return callback(new Error(this.$t('company.selectCountry')))
      }
      if (this.copyDetails.phone && value.substr(3, 5) === '*****') {
        if (value !== this.phoneFormat(this.companyDetails.phone)) {
          return callback(new Error(window.vm.$t('common.phoneValid')))
        }
      }
      return callback()
    }
    let checkEmail = (rules, value, callback) => {
      if (
        this.copyDetails.email &&
        (value.substr(2, 3) === '***' || value.substr(1, 3) === '***')
      ) {
        if (value !== this.emailFormat(this.companyDetails.email)) {
          return callback(new Error(window.vm.$t('common.emailValid')))
        }
      }
      callback()
    }
    return {
      activeName: '1',
      isShowAdminAccount: 0,
      datas: {
        id: ''
      },
      params: {
        companyId: ''
      },
      companyDetails: {},
      copyDetails: {},
      imgUrl: '',
      contryData: {},
      phonePrefix: '',
      dialogVisible: false,
      rules: {
        companyName: validatorInputEmptyRule(true, 100),
        phone: validatorPhoneRule(false, checkPhone),
        email: validatorEmailRule(true, checkEmail)
      },
      contryCode: []
    }
  },

  watch: {
    isShowAdminAccount: {
      handler(val) {
        if (val === undefined) return
        this.isShowAdminAccount = val
      },
      immediate: true
    }
  },
  mounted() {
    let companyDetail = JSON.parse(sessionStorage.getItem('companyDetail'))
    this.params.companyId = companyDetail.companyId
    this.isShowAdminAccount = +companyDetail.companyManagerOn

    this.loadContryCode()
    this.getCompanyDetail()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      if (this.$refs.companyDetailsForm) {
        this.$refs.companyDetailsForm.resetFields()
      }
    },
    loadContryCode() {
      companyApi.loadCountry().then(data => {
        this.contryCode = []
        this.contryData = data
        let key = Object.keys(data)
        key.forEach(item => {
          this.contryCode.push({
            key: this.$t('contry.' + item),
            value: item
          })
        })
      })
    },
    sumbitEdit() {
      this.$refs.companyDetailsForm.validate(valid => {
        if (valid) {
          // 提交之前 判断邮箱和手机号 是否改变
          let params = { ...this.copyDetails }
          params.email =
            this.copyDetails.email ===
            this.emailFormat(this.companyDetails.email)
              ? this.companyDetails.email
              : this.copyDetails.email
          params.phone =
            this.copyDetails.phone ===
            this.phoneFormat(this.companyDetails.phone)
              ? this.companyDetails.phone
              : this.copyDetails.phone
          companyApi
            .updateCompanyDetails(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  message: this.$t('common.saveSucess'),
                  type: 'success'
                })
                this.getCompanyDetail()
                this.dialogVisible = false
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log(e))
        }
      })
    },
    getCompanyDetail() {
      companyApi
        .getCompanyDetails(this.params)
        .then(data => {
          if (data.code === '00000000') {
            this.companyDetails = data.payload.results.companyDetails
            !this.companyDetails.email && (this.companyDetails.email = '')
            !this.companyDetails.phone && (this.companyDetails.phone = '')
            this.copyDetails = JSON.parse(JSON.stringify(this.companyDetails))
            let compayDetails = data.payload.results.companyDetails
            this.imgUrl = compayDetails.logo
            // eslint-disable-next-line
            this.phonePrefix = this.companyDetails.prefix = this.contryData[
              compayDetails.countryCode
            ]
            this.copyDetails.email = this.copyDetails.email
              ? this.emailFormat(this.copyDetails.email)
              : ''
            this.copyDetails.phone = this.copyDetails.phone
              ? this.phoneFormat(this.copyDetails.phone)
              : ''
            this.datas.id = this.companyDetails.id
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {})
    },
    goBack() {
      sessionStorage.removeItem('companyDetail')
      this.$router.push({
        path: '/tenantManager/companyInfo'
      })
    },
    handleClick(tab) {
      this.activeName = tab.name
    },
    editCompany() {
      this.dialogVisible = true
    },

    changeCountry(data) {
      let phonePrefix = this.contryData[data]
      if (phonePrefix) {
        this.phonePrefix = phonePrefix
      }
    },
    uploadError() {
      this.$message.error(this.$t('common.uploadFail'))
    },
    handleAvatarSuccess(res, fileInfo) {
      if (res.code === '00000000') {
        this.companyDetails.logo = res.payload.results.url
        this.imgUrl = res.payload.results.url
        this.$message.success(this.$t('common.uploadSuccess'))
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error(this.$t('common.uploadCompanyLogo'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.uploadCompanyLogoSize'))
        return false
      }
      return isJPG && isLt2M
    }
  },
  components: {
    adminAccount,
    companyDevice,
    companyInformaion,
    companyEmployee
  }
}
</script>
<style scoped lang="less">
.flex-display-cla {
  display: flex;
  .flex-item-cla {
    flex-grow: 1;
  }
}
.edit_company {
  cursor: pointer;
  margin-left: 20px;
  color: #7ac143;
}

.upload-demo {
  margin-left: 10px;
  .upload_div {
    width: 82px;
    height: 82px;
    line-height: 82px;
    border: 1px dashed #d9d9d9;
    border-radius: 3px;
    font-size: 20px;
    background-color: #f4f6fa;
  }
  .upload_div:hover {
    border-color: #7ac143;
    color: #7ac143;
  }
  .el-upload__tip {
    width: 400px;
  }
  .avatar {
    width: 82px;
    height: 82px;
    border: 1px dashed #d9d9d9;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/companyDetail.vue